"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBWhatsappNegative = function SvgBWhatsappNegative(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M2.323 143.729a2.323 2.323 0 01-2.184-3.097l12.511-34.567A70.359 70.359 0 0173.246-.001 69.565 69.565 0 01117.12 15.36a2.323 2.323 0 11-2.895 3.631A65.032 65.032 0 0073.246 4.645a65.706 65.706 0 00-56.051 99.949c.369.602.443 1.34.201 2.005L6.194 137.535l17.38-6.294a2.323 2.323 0 011.549 4.367L3.097 143.59c-.248.09-.51.137-.774.139z"
  }), (0, _core.jsx)("path", {
    d: "M73.246 140.671a70.397 70.397 0 01-52.753-23.822 2.33 2.33 0 113.484-3.097c18.063 20.496 46.926 27.672 72.484 18.02 25.557-9.653 42.471-34.117 42.476-61.437a64.978 64.978 0 00-14.199-40.792 2.323 2.323 0 113.639-2.888 69.58 69.58 0 0115.205 43.68c-.064 38.82-31.517 70.272-70.336 70.336z"
  }), (0, _core.jsx)("path", {
    d: "M79.463 100.645c-.337 0-.67-.074-.975-.217A80.733 80.733 0 0155.324 84.21a81.213 81.213 0 01-11.567-14.532 2.323 2.323 0 113.941-2.454 77.001 77.001 0 0010.908 13.734 76.057 76.057 0 0021.84 15.283 2.323 2.323 0 01-.983 4.436v-.03zM83.613 88.63c-.352 0-.7-.083-1.014-.24a68.02 68.02 0 01-18.34-13.107 64.593 64.593 0 01-2.564-2.702 2.323 2.323 0 013.461-3.097c.774.851 1.549 1.703 2.385 2.524a63.437 63.437 0 0017.102 12.217 2.323 2.323 0 01-1.022 4.412l-.008-.007z"
  }), (0, _core.jsx)("path", {
    d: "M46.049 71.226a2.323 2.323 0 01-1.92-.983c-3.77-5.528-9.5-20.176-1.966-27.662 6.193-6.194 11.357-7.309 15.352-3.314 2.91 2.872 5.272 10.281 5.566 15.035.21 3.422-2.725 7.672-4.753 9.7a2.323 2.323 0 11-3.283-3.282c1.827-1.835 3.484-4.808 3.399-6.132-.279-4.513-2.547-10.413-4.212-12.077-.82-.774-2.74-2.733-8.787 3.314C40.56 50.71 44.423 62.43 48 67.618a2.323 2.323 0 01-.612 3.228 2.253 2.253 0 01-1.339.38zM93.337 104.121c-6.805 0-14.06-3.096-17.094-4.792a2.327 2.327 0 012.322-4.034c5.358 3.097 17.303 6.705 21.956 1.634 5.784-6.294 3.786-8.129 2.934-8.91-1.625-1.503-7.045-3.245-11.86-3.338-1.549 0-4.893 1.688-6.364 3.29a2.323 2.323 0 11-3.414-3.143c1.835-2.005 6.395-4.862 9.87-4.792 5.002.1 11.947 1.827 14.912 4.56 4.165 3.825 3.267 9.035-2.656 15.484-2.764 2.988-6.611 4.041-10.606 4.041z"
  })));
};

var _default = SvgBWhatsappNegative;
exports["default"] = _default;